import styled from "styled-components";

export const Spacer = styled.div`
    height: ${props => props.size ? props.size + 'px' : '20px'}
`;